import { Dimension } from '@components/dialogs/UploadImageDialog/interfaces';

export const SCORECARD_MIN_DIMENSION: Dimension = {
  width: 640,
  height: 480,
};
